/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function DeviceRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.applications.integrations', {
            url: '/:applicationId/integrations',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value,
                   types.authority.SUB_CUSTOMER_ADMIN.value, types.authority.SUB_CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'integration.integrations'
            },
            ncyBreadcrumb: {
                label: '{"icon": "extension", "label": "integration.integrations"}'
            },
            params: {
                entityId: null,
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, integrationTableConfig) {
                        return integrationTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.subCustomers.applications.integrations', {
            url: '/:applicationId/integrations',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'integration.integrations'
            },
            ncyBreadcrumb: {
                label: '{"icon": "extension", "label": "integration.integrations"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, integrationTableConfig) {
                        return integrationTableConfig.getConfig($stateParams);
                    }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/integration/integration.routes.js